module.exports = __webpack_public_path__ + "static/media/close-feedback-icon.86e23375.svg";